import React, { useEffect, ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useNavigationItemStyles, useNavigationStyles } from './navigation-styles';

import { Tabs, Tab } from '@mui/material';
import { SyntheticEvent } from 'react';

export interface IThemeTab {
    title: string;
    value: string;
    path?: string;
    action?: () => void;
    titleAsKeyForTranslation?: boolean;
}

interface NavigationProps {
    tabs: IThemeTab[];
    activeTab?: string;
    namespaces?: string[];
    tabsClassName?: string;
    disabled?: boolean;
}

export const Navigation = (props: NavigationProps): ReactElement => {
    const { tabs, activeTab, namespaces, tabsClassName, disabled } = props;

    const { t } = useTranslation(namespaces);
    const navigate = useNavigate();

    const navigationClasses = useNavigationStyles();
    const navigationItemClasses = useNavigationItemStyles();

    useEffect(() => {
        window.dispatchEvent(new CustomEvent('resize'));
    }, []);

    const handleOnChangeTab = (_: SyntheticEvent, value: string): void => {
        const tab = tabs.find((tab) => value === tab.value);
        if (tab?.path) {
            navigate(tab.path);
            return;
        }
        if (tab?.action) {
            tab.action();
        }
    };

    return (
        <Tabs
            value={activeTab}
            classes={navigationClasses}
            className={tabsClassName}
            onChange={handleOnChangeTab}
        >
            {tabs.map(({ title, value, titleAsKeyForTranslation }) => {
                return (
                    <Tab
                        disableRipple
                        disabled={disabled}
                        key={value}
                        label={titleAsKeyForTranslation ? t(title) : title}
                        classes={navigationItemClasses}
                        value={value}
                    />
                );
            })}
        </Tabs>
    );
};
